import * as $ from "jquery";
import * as _ from "lodash";
import { BaseModifyDashboardWidgetViewOptions } from "../_BaseModifyWidgetView";
import { ModifySimpleWidgetView } from "../simplewidget/SimpleWidget";

export class ModifySensitivityWidget extends ModifySimpleWidgetView {

    protected template = _.template(require('templates/modals/dashboard/modify_widgets/sensitivity/sensitivity.html'));
    protected channelsTemplate = _.template(require('templates/modals/dashboard/modify_widgets/sensitivity/sensitivitychannels.html'));
    protected levelTemplate = _.template(require('templates/modals/dashboard/modify_widgets/sensitivity/sensitivitylevel.html'));
    protected thresholdsTemplate = _.template(require('templates/modals/dashboard/modify_widgets/sensitivity/sensitivitythresholds.html'));
    private sensitivityLevels = [];

    constructor(options: BaseModifyDashboardWidgetViewOptions) {
        super(<any>_.extend({
            events: {
                'click .add-sensitivity': 'handleAddSensitivityLevel',
                'input .sensitivity-level': 'updateThresholdSensitivities',
                'click .sensitivity-level-delete': 'handleDeleteSensitivityLevel'
            }
        }, options));
    }

    render() {
        super.render();
        this.renderSensitivityRows();
        return this;
    }

    private renderSensitivityRows() {
        this.sensitivityLevels = JSON.parse(this.options.widget.getParamValue('SENSITIVITY_LEVELS', '["Lowest Sensitivity"]'));

        _.each(this.sensitivityLevels, (level, i) => {
            this.renderSensitivityRow(i + 1, level);

            _.each(this.$('.channel-selects'), (row) => {
                this.renderChannelThresholdRow(row);
            });
        });

        this.updateThresholdSensitivities();
    }

    private renderSensitivityRow(order: number, level: string) {
        this.$('.sensitivity-levels').append(this.levelTemplate({
            order,
            level
        }));
    }

    private renderChannelThresholdRow(channelSelectRow) {
        $(channelSelectRow).find('.thresholds-container').append(this.thresholdsTemplate({
            advancedConfig: this.advancedConfig
        }));
    }

    private handleAddSensitivityLevel() {
        var name = 'Sensitivity Level';
        var order = this.sensitivityLevels.push(name);
        this.renderSensitivityRow(order, name);

        _.each(this.$('.channel-selects'), (row) => {
            this.renderChannelThresholdRow(row);
            // enable "use defaults" thresholds button
            const useDefaultsButton = $(row).find('.use-defaults-btn');
            useDefaultsButton.removeAttr('disabled');
            
            // Use the existing updateThresholdRow method to properly set unit for new threshold row
            const channelSelect = $(row).find('.widget-channel-select-channel');
            const channelId = Number(channelSelect.val());
            if (channelId) {
                const installSelect = $(row).find('.widget-channel-select-install');
                const installId = String($(installSelect).val());
                const moduleSelect = $(row).find('.widget-channel-select-module');
                const moduleNumber = moduleSelect.val();
                const module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
                const channel = module.getChannelById(channelId);
                const unit = channel['channel_unit'];
                
                // Use the existing updateThresholdRow method to properly set the unit
                const newThresholdRow = $(row).find('.channel-thresholds').last();
                this.updateThresholdRow(newThresholdRow, channelId, [], unit);
            }
        });
    }

    private updateThresholdSensitivities() {
        this.sensitivityLevels = _.map(this.$('.sensitivity-level'), (e) => $(e).val());

        _.each(this.$('.channel-selects'), (channelRow) => {
            var $channelRow = $(channelRow);
            _.each($channelRow.find('.channel-thresholds'), (thresholdsRow, i) => {
                var $thresholdsRow = $(thresholdsRow);
                $thresholdsRow.find('.threshold-label span').text(this.sensitivityLevels[i] + ' Tresholds')
            });
        });
    };

    protected renderNewChannelRow(installId?: number, dashboardChannelOrder?: number, channelsLength?: number) {
        var newChannelRow = super.renderNewChannelRow(installId, dashboardChannelOrder, channelsLength);

        _.each(this.sensitivityLevels, (level) => {
            this.renderChannelThresholdRow(newChannelRow);
        });

        this.updateThresholdSensitivities();
        return newChannelRow;
    }

    protected handleChannelSelectChange(e: JQuery.UIEventBase) {
        //super.handleChannelSelectChange(e);

        var channelSelect = $(e.currentTarget);
        var channelId = Number(channelSelect.val());
        var container = $(channelSelect).parents('.channel-selects');
        var useDefaultsButton = container.find('.use-defaults-btn');

        // Clear current ranges
        const thresholdsWrapper = container.find('.thresholds-wrapper');
        thresholdsWrapper.empty();
        const channelThresholdsRow = container.find('.channel-thresholds');
        this.setMultirangeThresholdQty(channelThresholdsRow);
        useDefaultsButton.prop('disabled', true);

        if (!channelId) return;

        var installSelect = container.find('.widget-channel-select-install');
        var installId = (<string>$(installSelect).val());
        var moduleSelect = container.find('.widget-channel-select-module');
        var moduleNumber = moduleSelect.val();
        var module = this.options.moduleCollections[installId].findWhere({ module_number: moduleNumber });
        var channel = module.getChannelById(channelId);
        var unit = channel['channel_unit'];
        var dashboardChannelId = Number(container.find('.widget-dashboard-channel-id').val());

        var dashboardChannel = this.options.dashboardChannelCollection.findWhere({
            dashboard_channel_id: dashboardChannelId,
            dashboard_widget_id: this.options.widget.get('id'),
            channel_id: channelId
        });
        var channelNameInput = container.find('.widget-channel-label').val('');
        if (dashboardChannel) {
            channelNameInput.val(dashboardChannel.get('dashboard_channel_name'));
        }

        if (channelNameInput.val() == '') {
            channelNameInput.val(module.get('module_location') + ' - ' + channel['channel_name']);
        }
        channelNameInput.prop('disabled', false);
        // Enable defaults button
        useDefaultsButton.prop('disabled', false);
        
        var values = JSON.parse(this.options.widget.getParamValue('SENSITIVITY_VALUES', '{}'));
        if (_.has(values, dashboardChannelId) && dashboardChannel) {
            _.each(container.find('.channel-thresholds'), (thresholdsRow, i) => {
                var $thresholdsRow = $(thresholdsRow);
                this.updateThresholdRow($thresholdsRow, channelId, values[dashboardChannelId][i], unit);
            });
        } else if (dashboardChannel) {
            _.each(container.find('.channel-thresholds'), (thresholdsRow, i) => {
                var $thresholdsRow = $(thresholdsRow);
                this.updateThresholdRow($thresholdsRow, channelId, dashboardChannel.get('rangesList'), unit);
            });
        } else {
            _.each(container.find('.channel-thresholds'), (thresholdsRow) => {
                var $thresholdsRow = $(thresholdsRow);
                this.updateThresholdRow($thresholdsRow, null, null, unit);
            });
        }
        this.checkCanSaveWidget();
    }

    private handleDeleteSensitivityLevel(e) {
        var iconClicked = $(e.currentTarget);
        var indexClicked = _.findIndex(_.map(this.$('.sensitivity-level-delete'), (e) => e === iconClicked.get(0)));

        // Remove the sensitivity level input
        this.$(`.sensitivity-levels > div:nth-child(${indexClicked + 1})`).remove();

        // Fix the "Level" label
        _.each(this.$('.sensitivity-levels .sensitivity-level-label'), (label, i) => {
            $(label).text(`Level ${i + 1}`);
        });

        // Remove threshold rows
        this.$(`.thresholds-container > div:nth-child(${indexClicked + 1})`).remove();

        // Recompute thresholds labels
        this.updateThresholdSensitivities();
    }

    private buildAndSetSensitivityParams(): void {
        this.options.widget.setParamValue('SENSITIVITY_LEVELS', JSON.stringify(this.sensitivityLevels));
        this.options.widget.setParamValue('SENSITIVITY_ACTIVE', _.first(this.sensitivityLevels));
        this.options.widget.setParamValue('ADVANCED_CONFIG', this.advancedConfig);
        this.options.widget.setParamValue('USE_CUSTOM_LABELS', this.useCustomLabels);

        var values = {};
        var widgetChannels = this.options.dashboardChannelCollection.where({
            dashboard_widget_id: this.options.widget.get('id')
        });
        _.each(this.$('.channel-selects'), (channelRow, i) => {
            var $channelRow = $(channelRow);
            var channelId = $channelRow.find('.widget-channel-select-channel').val();
            if (!channelId) return;

            var dashboardChannel = _.find(widgetChannels, (c) => c.get('dashboard_channel_order') === i);
            if (!dashboardChannel) return;

            var dashboardChannelId = Number(dashboardChannel.get('dashboard_channel_id'));
            values[dashboardChannelId] = _.map($channelRow.find('.thresholds-container .channel-thresholds'), (thresholdsRow) => {
                var rangesList = this.advancedConfig ? this.getRangesListFromAdvancedThresholds(thresholdsRow) : this.getRangesListFromRegularThresholds(thresholdsRow);
                return rangesList;
            });
        });
        if (!_.isEmpty(values)) {
            this.options.widget.setParamValue('SENSITIVITY_VALUES', JSON.stringify(values));
        }
    }

    postSave() {
        // Build params from DOM + collection (modal defers tab move until after this, so channels are still in collection)
        this.buildAndSetSensitivityParams();

        // the API for postSave is synchronous, but this implementation requires handling of an async XHR operation -- problem!
        this.options.widget.save(); // TODO: fix to not drop the outcome of the XHR
        return true;
    }

    protected setExampleImg() {
        this.$('.example img').attr('src', require('../../../../../../img/widgettypes/sensitivity.png'));
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/views/modals/dashboard/modify_widgets/sensitivity/ModifySensitivityWidget.ts